export const DEFAULT_ABOUT_DETAILS_SUBTITLE =
  "Join our first digital conference";
export const DEFAULT_ABOUT_DETAILS_DESCRIPTION =
  "We’re here to help shape the future in a sustainable way. Our team is made of experts that help companies invest in renewable energy, and we support many initiatives to make the food industry more sustainable for our planet.";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_1 =
  "Learn what the best minds in the industry are focusing on";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_2 =
  "Skip the cliches and dive deep into the real issues around sustainability and renewable energy";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_3 =
  "Get an insider view on how the leading companies in the industry see the future; what they want the world to look like 50 years from now, and how they’re planning to get there";
export const DEFAULT_ABOUT_DETAILS_LIST_ITEM_4 =
  "Connect with other top professionals and find new opportunities to join forces and drive positive change";
export const DEFAULT_ABOUT_DETAILS_CTA_TEXT = "Register";
